import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CustomDialog from '@/components/custom-dialog/CustomDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormModalShell',
  props: {
    isDisplay: { type: Boolean },
    title: {},
    width: { default: '50%' },
    size: { default: 'xl' },
    closeOnBackdropClick: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomDialog, {
    "is-display": _ctx.isDisplay,
    title: _ctx.title,
    width: _ctx.width,
    size: _ctx.size,
    "close-on-backdrop-click": _ctx.closeOnBackdropClick,
    onOnCloseIconClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, _createSlots({
    "dialog-content": _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (_ctx.$slots.footer)
      ? {
          name: "dialog-footer",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "footer")
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["is-display", "title", "width", "size", "close-on-backdrop-click"]))
}
}

})